export const EMPLOYEE_STATUS_OPTIONS = Object.freeze([
  {
    key: 'active',
    value: 'ACTIVE',
  },
  {
    key: 'suspended',
    value: 'SUSPENDED',
  },
  {
    key: 'locked',
    value: 'LOCKED',
  },
  {
    key: 'deleted',
    value: 'DELETED',
  },
  // Set only by the termination / archive flows, listed so the label shows.
  {
    key: 'terminated',
    value: 'TERMINATED',
    disabled: true,
  },
  {
    key: 'archived',
    value: 'ARCHIVED',
    disabled: true,
  },
]);

export const WORK_TYPE_VALUES = Object.freeze({
  fullTime: 100,
  halfTime: 50,
  customTime: undefined,
});

export const EMPLOYEE_WORK_TYPE_OPTIONS = Object.freeze([
  { key: 'fullTime', value: 'fullTime' },
  { key: 'halfTime', value: 'halfTime' },
  { key: 'customTime', value: 'customTime' },
]);

export const EMPLOYEE_WORK_TYPES_OPTIONS = Object.freeze([
  { label: 'fulltime', value: 'fullTime' },
  { label: 'halftime', value: 'halfTime' },
  { label: 'customtime', value: 'customTime' },
]);

export const TYPE_OF_EMPLOYEE_OPTIONS = Object.freeze([
  { key: 'newEmployee', value: 'new' },
  { key: 'existingEmployee', value: 'existing' },
]);

// Stored employment-type values used by filters and the extend-employment modal.
// Kept to the two classic employment relationships so those consumers stay
// unchanged; the create/edit form uses EMPLOYMENT_CATEGORY_OPTIONS instead.
export const EMPLOYMENT_TYPE_OPTIONS = Object.freeze([
  { key: 'unlimitedEmployment', value: 'unlimited' },
  { key: 'limitedEmployment', value: 'limited' },
]);

// Top-level categories shown as radio buttons in the employee form. 'special' is
// a UI-only category (never stored) — selecting it reveals
// SPECIAL_EMPLOYMENT_OPTIONS, and the concrete sub-type
// (ugovorODelu/autorskiUgovor/...) is what gets stored in
// employmentSettings.employmentType.
export const EMPLOYMENT_CATEGORY_OPTIONS = Object.freeze([
  { key: 'unlimitedEmployment', value: 'unlimited' },
  { key: 'limitedEmployment', value: 'limited' },
  { key: 'specialEmployment', value: 'special' },
]);

// Concrete non-employment contract types shown under the "Special" category.
// These are the values actually stored in employmentSettings.employmentType.
export const SPECIAL_EMPLOYMENT_OPTIONS = Object.freeze([
  { key: 'contractWork', value: 'ugovorODelu' },
  { key: 'authorContract', value: 'autorskiUgovor' },
  { key: 'supplementaryWork', value: 'dopunskiRad' },
  { key: 'temporaryWork', value: 'ppPoslovi' },
]);

// Non-employment contracts (outside employment) — no annual leave, payroll goes
// through OZ "other income". The form treats them like "limited" (shows the end
// date), but without the annual-leave calculation.
export const NON_EMPLOYMENT_TYPE_VALUES = Object.freeze(
  SPECIAL_EMPLOYMENT_OPTIONS.map((o) => o.value)
);

export const isNonEmploymentTypeValue = (value) =>
  NON_EMPLOYMENT_TYPE_VALUES.includes(value);

// Bologna / ISCED-aligned bands shared across SR / PL / AL markets. Labels are
// resolved via i18n (key prefix `educationLevels.<key>`).
export const EDUCATION_LEVEL_OPTIONS = Object.freeze([
  { key: 'noFormalEducation', value: 'noFormalEducation' },
  { key: 'primary', value: 'primary' },
  { key: 'vocational', value: 'vocational' },
  { key: 'secondary', value: 'secondary' },
  { key: 'postSecondary', value: 'postSecondary' },
  { key: 'bachelor', value: 'bachelor' },
  { key: 'master', value: 'master' },
  { key: 'doctorate', value: 'doctorate' },
]);

// Serbian companies state the national degree (I–VIII stepen) in HR
// documents; `other` takes free text for anything the list does not cover.
export const RS_EDUCATION_LEVEL_OPTIONS = Object.freeze([
  { key: 'rsLevel1', value: 'rsLevel1' },
  { key: 'rsLevel2', value: 'rsLevel2' },
  { key: 'rsLevel3', value: 'rsLevel3' },
  { key: 'rsLevel4', value: 'rsLevel4' },
  { key: 'rsLevel5', value: 'rsLevel5' },
  { key: 'rsLevel6', value: 'rsLevel6' },
  { key: 'rsLevel7', value: 'rsLevel7' },
  { key: 'rsLevel8', value: 'rsLevel8' },
  { key: 'other', value: 'other' },
]);

export const EMPLOYEES_BULK_ACTION_OPTIONS = Object.freeze([
  {
    key: 'sendInvitations',
    value: 'sendInvitations',
    groupKey: 'invitations',
    groupValue: 'invitations',
    dotColor: 'bg-primary',
  },
]);
